import { render, staticRenderFns } from "./StudentMiniCardUI.vue?vue&type=template&id=36f9b3ca&lang=pug&"
import script from "./StudentMiniCardUI.vue?vue&type=script&lang=js&"
export * from "./StudentMiniCardUI.vue?vue&type=script&lang=js&"
import style0 from "./StudentMiniCardUI.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports